import styles from "./error.module.css";
import Button from "../button/Button";

const ApiErrorPage = (props) => {
  const {
    setError,
    setCardClicked,
    setSelectedConnector,
    InitialFetchData,
    setConnectorid,
    setChargerId,
    setDisplayid,
    setChargingInProgressFirstScreen,
  } = props;

  return (
    <>
      <div className={styles.errorOuter}>
        <div className={styles.imageContainer}>
          <img src="/assets/PinImage.svg" className={styles.pinImage} />
        </div>
        <div className={styles.buttonContainer}>
          <Button
            className={"enableConnectorButton"}
            disabled={false}
            value={"Retry"}
            onClick={() => {
              setError(null);
              setCardClicked(false);
              setSelectedConnector({
                containerIndex: null,
                connectorIndex: null,
              });
              setConnectorid(null);
              setChargerId(null);
              setDisplayid(null);
              setChargingInProgressFirstScreen(false);
              InitialFetchData();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ApiErrorPage;
